import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { isImageSupportNativeLazy as f } from "../../_utils/env/is-native-lazy-load.js";
import { imageGroupInjectionKey as b } from "./ImageGroup.js";
import p from "./ImagePreview.js";
import { imageContextKey as w, imagePreviewSharedProps as O } from "./interface.js";
import { observeIntersection as S } from "./utils.js";
import P from "../../_mixins/use-config.js";
import { resolveSlot as E } from "../../_utils/vue/resolve-slot.js";
import { defineComponent as I, inject as j, onMounted as m, watchEffect as u, onBeforeUnmount as y, provide as L, h as g } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as h, toRef as C } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const R = Object.assign({
  alt: String,
  height: [String, Number],
  imgProps: Object,
  previewedImgProps: Object,
  lazy: Boolean,
  intersectionObserverOptions: Object,
  objectFit: {
    type: String,
    default: "fill"
  },
  previewSrc: String,
  fallbackSrc: String,
  width: [String, Number],
  src: String,
  previewDisabled: Boolean,
  loadDescription: String,
  onError: Function,
  onLoad: Function
}, O), A = I({
  name: "Image",
  props: R,
  slots: Object,
  inheritAttrs: !1,
  setup(o) {
    const n = h(null), l = h(!1), s = h(null), i = j(b, null), {
      mergedClsPrefixRef: v
    } = i || P(o), d = {
      click: () => {
        if (o.previewDisabled || l.value)
          return;
        const e = o.previewSrc || o.src;
        if (i) {
          i.setPreviewSrc(e), i.setThumbnailEl(n.value), i.toggleShow();
          return;
        }
        const {
          value: r
        } = s;
        r && (r.setPreviewSrc(e), r.setThumbnailEl(n.value), r.toggleShow());
      }
    }, a = h(!o.lazy);
    m(() => {
      var e;
      (e = n.value) === null || e === void 0 || e.setAttribute("data-group-id", (i == null ? void 0 : i.groupId) || "");
    }), m(() => {
      if (o.lazy && o.intersectionObserverOptions) {
        let e;
        const r = u(() => {
          e == null || e(), e = void 0, e = S(n.value, o.intersectionObserverOptions, a);
        });
        y(() => {
          r(), e == null || e();
        });
      }
    }), u(() => {
      var e;
      o.src || ((e = o.imgProps) === null || e === void 0 || e.src), l.value = !1;
    });
    const c = h(!1);
    return L(w, {
      previewedImgPropsRef: C(o, "previewedImgProps")
    }), Object.assign({
      mergedClsPrefix: v,
      groupId: i == null ? void 0 : i.groupId,
      previewInstRef: s,
      imageRef: n,
      showError: l,
      shouldStartLoading: a,
      loaded: c,
      mergedOnClick: (e) => {
        var r, t;
        d.click(), (t = (r = o.imgProps) === null || r === void 0 ? void 0 : r.onClick) === null || t === void 0 || t.call(r, e);
      },
      mergedOnError: (e) => {
        if (!a.value)
          return;
        l.value = !0;
        const {
          onError: r,
          imgProps: {
            onError: t
          } = {}
        } = o;
        r == null || r(e), t == null || t(e);
      },
      mergedOnLoad: (e) => {
        const {
          onLoad: r,
          imgProps: {
            onLoad: t
          } = {}
        } = o;
        r == null || r(e), t == null || t(e), c.value = !0;
      }
    }, d);
  },
  render() {
    var o, n;
    const {
      mergedClsPrefix: l,
      imgProps: s = {},
      loaded: i,
      $attrs: v,
      lazy: d
    } = this, a = E(this.$slots.error, () => []), c = (n = (o = this.$slots).placeholder) === null || n === void 0 ? void 0 : n.call(o), e = this.src || s.src, r = this.showError && a.length ? a : g("img", Object.assign(Object.assign({}, s), {
      ref: "imageRef",
      width: this.width || s.width,
      height: this.height || s.height,
      src: this.showError ? this.fallbackSrc : d && this.intersectionObserverOptions ? this.shouldStartLoading ? e : void 0 : e,
      alt: this.alt || s.alt,
      "aria-label": this.alt || s.alt,
      onClick: this.mergedOnClick,
      onError: this.mergedOnError,
      onLoad: this.mergedOnLoad,
      // If interseciton observer options is set, do not use native lazy
      loading: f && d && !this.intersectionObserverOptions ? "lazy" : "eager",
      style: [s.style || "", c && !i ? {
        height: "0",
        width: "0",
        visibility: "hidden"
      } : "", {
        objectFit: this.objectFit
      }],
      "data-error": this.showError,
      "data-preview-src": this.previewSrc || this.src
    }));
    return g("div", Object.assign({}, v, {
      role: "none",
      class: [v.class, `${l}-image`, (this.previewDisabled || this.showError) && `${l}-image--preview-disabled`]
    }), this.groupId ? r : g(p, {
      theme: this.theme,
      themeOverrides: this.themeOverrides,
      clsPrefix: l,
      ref: "previewInstRef",
      showToolbar: this.showToolbar,
      showToolbarTooltip: this.showToolbarTooltip,
      renderToolbar: this.renderToolbar
    }, {
      default: () => r
    }), !i && c);
  }
});
export {
  A as default,
  R as imageProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/image/src/Image.js
// module id = 334
// module chunks = 67